import { ReactNode } from "react";
import {
  AlertsContext,
  AlertsContextType,
} from "./AlertsContext";

interface Props {
  children: ReactNode;
  value: AlertsContextType;
}

const AlertsProvider = ({
  children,
  value,
}: Props) => {
  return (
    <AlertsContext.Provider value={value}>
      {children}
    </AlertsContext.Provider>
  );
};

export default AlertsProvider;